import { use, useEffect, useState } from 'react';

import { SiteContext } from 'src/context/site-context';
import { BuildType } from 'src/enums/build/build-type';
import {
  FEATURE_FLAG,
  getFeatureFlag,
  getFeatureFlagAtClub,
} from 'src/helpers/feature-flag-helper';

const usePuzzelLiveChatFeatureFlag = (): boolean | null => {
  const { buildType, isGlobalPage, siteId } = use(SiteContext);

  const isPuzzelAllowedOnPage = buildType === BuildType.DAVID_LLOYD_UK || !isGlobalPage;

  const [isPuzzelEnabled, setIsPuzzelEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    if (!isPuzzelAllowedOnPage) {
      return;
    }
    let cancelled = false;
    const getPuzzelFeatureFlagValue = () =>
      isGlobalPage
        ? getFeatureFlag(FEATURE_FLAG.PUZZEL_LIVE_CHAT_INSTEAD_OF_TAWK)
        : getFeatureFlagAtClub(siteId, FEATURE_FLAG.PUZZEL_LIVE_CHAT_INSTEAD_OF_TAWK);

    getPuzzelFeatureFlagValue()
      .then((usePuzzelLiveChat) => {
        if (!cancelled) setIsPuzzelEnabled(usePuzzelLiveChat);
      })
      .catch(() => {
        if (!cancelled) setIsPuzzelEnabled(false);
      });

    return () => {
      cancelled = true;
    };
  }, [isPuzzelAllowedOnPage, isGlobalPage, siteId]);

  return isPuzzelAllowedOnPage ? isPuzzelEnabled : false;
};

export default usePuzzelLiveChatFeatureFlag;
